var firebase = require('firebase');

var config = {
  apiKey: "AIzaSyBWMwXBPIDX3ccK3vFEAavVUvQVynaiGsU",
  authDomain: "dice-c8a85.firebaseapp.com",
  databaseURL: "https://dice-c8a85.firebaseio.com",
  storageBucket: "dice-c8a85.appspot.com",
  messagingSenderId: "25914806627"
};
firebase.initializeApp(config);

// Get a reference to the database service
var database = firebase.database();
var isLoaded = false;

// Internal storage of result list
var resultList = [];
var destinyTokens = [];

// What room is the user in?
var currentRoom = null;
var currentDiceType = null;

// List of things interested in updates –– TODO : Unsubscribe
var dbUpdateSubscribers = [];

var notifyAll = () => {
  dbUpdateSubscribers.forEach(callback => callback());
}

var start = function() {
  // Whenever a result comes in, we broadcast to subscribers
  // This also pertains to app init
  database.ref('results')
          .orderByChild('room').equalTo(currentRoom)
          .limitToLast(100)
          .on('child_added', data => {
    resultList = [
      {
        key: data.key,
        ...data.val()
      },
      ...resultList
    ].slice(0,100)

    // will want to prune likely
    notifyAll();
  });

  // Destiny Tokens
  database.ref(`room/${currentRoom}/destinyTokens`).on('value', tokens => {
    destinyTokens = tokens.val();
    notifyAll();
  });

  // Dice Type
  database.ref(`room/${currentRoom}/diceType`).on('value', diceType => {
    currentDiceType = diceType.val();
    isLoaded = true; // The loading event we really care about
    notifyAll();
  });
}

export default {
  start: () => {
    start();
  },
  isLoaded: () => {
    return isLoaded
  },

  subscribeDBUpdates: (callback) => {
    dbUpdateSubscribers.push(callback);
  },

  clearSubscriptions: () => {
    dbUpdateSubscribers = [];
  },


  clearResults: () => {
    resultList = [];
    notifyAll();
  },

  setRoom: room => {
    currentRoom = room;
  },
  getRoom: () => currentRoom,

  setDiceType: diceType => {
    database.ref(`room/${currentRoom}/diceType`).set(diceType);
  },
  getDiceType: () => currentDiceType,

  sendResult: (result) => {
    database.ref('results').push(result)
  },

  getResults: () => resultList,

  getDestinyTokens: () => {
    return destinyTokens;
  },

  setDestinyTokens: tokens => {
    database.ref(`room/${currentRoom}/destinyTokens`).set(tokens);
  }
}

/*
function setAllRoomEOT() {
  database.ref('/room/')
  .once('value').then(val => {
    Object.keys(val.val()).forEach(roomName => {
      database.ref(`/room/${roomName}/diceType`).set('EOT')
    });
  });
}
setAllRoomEOT();
*/
/*
// eslint-disable-next-line
function clearRoom(roomName) {
  database.ref('/results/')
    .orderByChild('room')
    .equalTo(roomName)
    .once('value').then(
      function (snapshot) {
        snapshot.forEach(function (child) {
          child.ref.remove();
        });
      }
    );
}

// Really dangerous to delete room results
// clearRoom('foogoo');
*/


// WEBPACK FOOTER //
// ./src/Database/Database.js